module.exports = __webpack_public_path__ + "img/AE.b280867b.svg";